import { render, staticRenderFns } from "./c-branch-dialog.vue?vue&type=template&id=74ca9477"
import script from "./c-branch-dialog.vue?vue&type=script&lang=js"
export * from "./c-branch-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ca9477')) {
      api.createRecord('74ca9477', component.options)
    } else {
      api.reload('74ca9477', component.options)
    }
    module.hot.accept("./c-branch-dialog.vue?vue&type=template&id=74ca9477", function () {
      api.rerender('74ca9477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/branch/c-branch-dialog.vue"
export default component.exports